import styles from "./styles/PosShoppingCart.module.css";
import InputText from "../../../components/ui/input_text/InputText";
import InputDate from "../../../components/ui/input_date/InputDate";
import InputTextArea from "../../../components/ui/input_text_area/InputTextArea";
import { t } from "i18next";

/**
 * Cheque form component
 */
const PosChequeForm = ({
    BANK_NAME,
    handleChange, // {Function} - Function to handle input changes
    formInput, // {Object} - The current form input values
    hoverFlag, // {Boolean} - Indicates if the hover flag is active
}) => {
    return (
        <div className={`${styles.payment_input_container}  v-flex-container `}>
            <div className={`${styles.payment_input_container} `}>
                <InputText
                    label={`${t("bank name")}`}
                    inputId={"bankName"}
                    inputValue={formInput?.bankName}
                    handleChangeFunction={handleChange}
                    // required={hoverFlag && !formInput?.bankName}
                    placeholder={`${t("required")}!`}
                    standardPlaceholder={t(BANK_NAME)}
                    textAlign={"left"}
                    type={"text"}
                    fullWidth={true}
                />
            </div>

            <div className={`${styles.double_container} flex-container`}>
                <div
                    className={`${styles.payment_input_container} ${styles.double}`}
                >
                    <InputText
                        label={`${t("check number")}*`}
                        inputId={"chequeNumber"}
                        inputValue={formInput?.chequeNumber}
                        handleChangeFunction={handleChange}
                        required={hoverFlag && !formInput?.chequeNumber}
                        placeholder={`${t("required")}!`}
                        textAlign={"left"}
                        type={"text"}
                        fullWidth={true}
                    />
                </div>
                <div
                    className={`${styles.payment_input_container} ${styles.double}`}
                >
                    <InputDate
                        label={`${t("check post date")}`}
                        inputId={"chequePostDate"}
                        inputValue={formInput?.chequePostDate}
                        handleChangeFunction={handleChange}
                        required={hoverFlag && !formInput?.chequePostDate}
                        fromToday={true}
                        fullWidth={true}
                    />
                </div>
            </div>

            <div
                className={`${styles.payment_input_container} ${styles.payment_comment}  flex-container`}
            >
                <InputTextArea
                    label={"comments"}
                    inputId={"comment"}
                    inputValue={formInput?.comment}
                    handleChangeFunction={handleChange}
                    textAlign={"left"}
                    type={"text"}
                    fullWidth={true}
                />
            </div>
        </div>
    );
};

export default PosChequeForm;
